import Json from '../Json' //测试用数据
import api from '@/api/index.js'
Date.prototype.Format = function(fmt) {
	var o = {
			"M+": this.getMonth() + 1, //月份
			"d+": this.getDate(), //日
			"H+": this.getHours(), //小时
			"m+": this.getMinutes(), //分
			"s+": this.getSeconds(), //秒
			"q+": Math.floor((this.getMonth() + 3) / 3), //季度
			"S": this.getMilliseconds() //毫秒
	};
	if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	for (var k in o)
			if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
	return fmt;
}
export default {
	getJsonData(key) {
		return Json[key]
	},

	getEnumDescription(key, value) {
		let list = Json[key];
		let data = list.find(p => p.value == value);
		if (data != null) {
			return data.name;
		}
		return null;
	},

	getDictionary(categroyName) {
		return new Promise((resolve) => {
			api.get(
				`dictionary/getDictionaryListByCategroyName?categroyName=${categroyName}`
			).then((rsp) => {
				if (rsp != false) {
					resolve(rsp.data);
				}
			});

		});
	},

	getDictionaryByCode(categroyCode) {
		return new Promise((resolve) => {
			api.get(
				`dictionary/GetDictionaryListByCategroyCode?categroyCode=${categroyCode}`
			).then((rsp) => {
				if (rsp != false) {
					resolve(rsp.data);
				}
			});

		});
	},


	parseDate(val) {
		try {
			return val.replace("T", " ");
		}
		catch{
			return "";
		}
	},

	//table操作栏按钮权限控制
	tablebuttonPermission(value) {
		let result = "inline-block"
		let permissions = [];
		let permissionAll = JSON.parse(localStorage.getItem("permission"));
		// console.log('permissions测试2',permissionAll,value)
		if (permissionAll) {
			permissions = permissionAll.filter((p) => p.privilegeType === '1');
		}
		let userpermissions = [];
		for (let menu of permissions) {
			userpermissions.push(menu.privilegeCode);
		}
		if (!userpermissions.includes(value)) {
			result = "none";
		}
		return result;
	}
}
